export default ({ COLORS }) => ({
  deleteGroup: {
    color: COLORS.RED.NORMAL
  }
})
